import { render, staticRenderFns } from "./infoLayout.vue?vue&type=template&id=a86f0f56&"
import script from "./infoLayout.vue?vue&type=script&lang=js&"
export * from "./infoLayout.vue?vue&type=script&lang=js&"
import style0 from "./infoLayout.vue?vue&type=style&index=0&id=a86f0f56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
